import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { LottieComponent, AnimationOptions } from 'ngx-lottie';
import { AnimationItem } from 'lottie-web';

@Component({
  selector: 'olr-loading-indicator',
  templateUrl: './loading-indicator.component.html',
  styleUrls: ['./loading-indicator.component.css'],
  imports: [LottieComponent],
})
export class LoadingIndicatorComponent implements OnInit {
  @ViewChild('loadingMessage', {static: true}) loadingMessage: ElementRef;

  options: AnimationOptions = {
    path: 'assets/animations/animation.json',
  };

  animationCreated(animationItem: AnimationItem): void {
    console.log(animationItem);
  }

  constructor() { }

  ngOnInit() {
    setTimeout( () => {
      this.loadingMessage.nativeElement.focus();
    }, 0);
  }

}